<template>
  <div>
    <div class="userContent">
      <el-form ref="form" :model="form" :rules="rules" label-position="left" label-width="80px">

        <el-form-item label="当前密码">
          <el-input v-model="form.originpass" type="password" placeholder="请输入密码"></el-input>
        </el-form-item>

        <el-form-item label="新密码">
          <el-input v-model="form.pass" type="password" placeholder="请输入密码"></el-input>
        </el-form-item>
        <el-form-item label="确认新密码">
          <el-input v-model="form.checkPass" type="password" placeholder="请再次输入密码"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSubmit">确认更改</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import md5 from "md5";
export default {
   props: ["propsname"],
  data() {
      
    var handlePasswordCheck = (rule, value, callback) => {
      let password = this.form.pass;
      if (value ==="") {
        callback(new Error("请输入密码"));
      }
      if (value && password && value.trim() !== password.trim()) {
        callback(new Error("两次密码不一致"));
      }
      else{callback()}
      
    };
    return {

      form: {
        name: "",
        originpass:"",
        pass: "",
        checkPass: ""
      },
      rules: {
        originpass: [
            { required: true, message: '请输入当前密码', trigger: 'blur' },
          ],
        pass: [{ required: true, message: '请输入密码', trigger: 'blur' }],
        checkPass: [{  required: true,validator: handlePasswordCheck, trigger: "blur" }]
      }
    };
  },
  methods: {
    handleSubmit () {
     this.$refs.form.validate((valid) => {
         if (valid) {
         this.$axios.post(url+"passchange", {
            name: this.$router.currentRoute.name==="passchange"?this.$store.state.user:this.propsname,
            originpass:md5(this.form.originpass),
            pass: md5(this.form.pass)
          })
       .then((res) => {
            //alert(res.data)
            if(res.data=="success"){
            this.$message.success("密码更改成功")
              if(this.$router.currentRoute.name==="passchange")
              {this.$router.push('/login')}

              this.$emit("done")
            }
            else{
              this.$message.error("密码更改失败，请再次确认密码")
            }
          }).catch(() => {
            this.$message.error('抱歉，密码更改失败')
          })
        }

     })

    },

  }
};
</script>

<style>

.userContent {
  width: 400px;
  margin: 15vh auto;
}
.select-sex {
  width: 320px;
}
</style>


// WEBPACK FOOTER //
// src/components/login/passchange.vue